import { useCallback } from 'react'
import { CheckBox } from '../../atoms'
import { FormItem } from './Component'

interface FormCheckBoxProps {
  name: string
  initialValue?: boolean
  ignoreErrorKeys?: string[]
  noMargin?: boolean
  label?: string
  [key: string]: any
}

interface ComponentProps {
  onChange?: (value: boolean) => void
  value?: boolean
  [key: string]: any
}

export const FormCheckBox = ({
  name,
  initialValue = false,
  ignoreErrorKeys,
  noMargin,
  label = '',
  ...props
}: FormCheckBoxProps) => {
  const Component = useCallback(
    ({ onChange, value, ...field }: ComponentProps) => (
      <CheckBox
        checked={Boolean(value)}
        onChange={(checked: boolean) => onChange?.(!Boolean(checked))}
        label={label}
        {...field}
        id={name}
        name={name}
        {...props}
      />
    ),
    [label],
  )

  return (
    <FormItem
      ignoreErrorKeys={ignoreErrorKeys}
      initialValue={initialValue}
      name={name}
      showErrorHelperText={false}
      noMargin={noMargin}
    >
      <Component />
    </FormItem>
  )
}
